<template>
    <Sidebar>
        <template slot-scope="{ collapsed }">
            <LocaleSelect :vertical="collapsed" />
            <img v-show="!collapsed" alt="kaminatrans-logo" class="w-100" id="logo" src="../../assets/images/kaminatrans-logo.png" />

            <!--
            <div class="d-flex flex-column">
                <router-link
                    class="btn btn-sm btn-primary w-100 mb-3"
                    to="/release-create"
                >
                    {{ __('New Release') }}
                </router-link>-->

                <!--<router-link-->
                    <!--class="btn btn-sm btn-cyan w-100"-->
                    <!--to="/shipping-document-create"-->
                <!--&gt;-->
                    <!--{{ __('Shipping documents export') }}-->
                <!--</router-link>-->
            <!--</div>-->
            <SidebarItem class="nav-item-primary" to="/release-create">
                <div class="icon icon-new"></div>
                <span>{{ __('New Release') }}</span>
            </SidebarItem>

            <SidebarItem to="/">
                <div class="icon icon-burger"></div>
                <span>{{ __('Panel') }}</span>
            </SidebarItem>
            <SidebarItem to="/releases">
                <div class="icon icon-transfer"></div>
                <span>{{ __('Releases') }}</span>
            </SidebarItem>
            <!--<SidebarItem icon="file-upload" to="/shipping-documents">{{ __('Shipping documents') }}</SidebarItem>-->
            <SidebarItem to="/shipments">
                <div class="icon icon-truck"></div>
                <span>{{ __('Shipments') }}</span>
            </SidebarItem>
            <!-- <SidebarItem icon="cube" to="/documents">{{ __('Documents') }}</SidebarItem>
            <SidebarItem to="/reports">
                <div class="icon icon-diagram"></div>
                <span>{{ __('Reports') }}</span>
            </SidebarItem>-->
            <SidebarItem to="/invoices">
                <div class="icon icon-file"></div>
                <span>{{ __('Invoices') }}</span>
            </SidebarItem>
            <SidebarItem to="/profile-edit">
                <div class="icon icon-gear"></div>
                <span>{{ __('Settings') }}</span>
            </SidebarItem>
            <SidebarItem to="#">
                <div @click.prevent="logout()" class="icon icon-logout"></div>
                <a @click.prevent="logout()" href="#">{{ __('Logout') }}</a>
            </SidebarItem>


            <div class="d-flex mt-auto mb-4">
               
                <div class="avatar-wrapper">
                 <avatar :fullname="$auth.user().title" :size="48"></avatar>              
                </div>
                <div class="avatar-text">
                    <span class="text-bold">{{ $auth.user().title }}</span>
                    <span class="text-silver small">{{ $auth.user().role }}</span>
                </div>
               
            </div>
        </template>
    </Sidebar>
</template>

<script>
import LocaleSelect from '../../plugins/LocaleSelect'
//import firebase from 'firebase/app'
//import 'firebase/messaging'
import Avatar from 'vue-avatar-component'


/*let firebaseConfig = {
  apiKey: 'AIzaSyC_J4pH7Nxh0ZysOzEWwW47pgH8WM3OVNM',
  authDomain: 'coldstoreexpress.firebaseapp.com',
  databaseURL: 'https://coldstoreexpress.firebaseio.com',
  projectId: 'coldstoreexpress',
  storageBucket: '',
  messagingSenderId: '301246646967',
  appId: '1:301246646967:web:d88edf6e5356c847'
}*/

export default {
  name: 'AppSidebar',

  created () {

   // firebase.initializeApp(firebaseConfig)

    //const messaging = firebase.messaging()

   /* if (Notification.permission === 'denied') {
      this.$api.notifications.unsubscribe(null)
    } else {
      Notification.requestPermission().then(() => {
        messaging.getToken().then((token) => {
          if (token) {
            this.$api.notifications.subscribe(token)
          } else {
            this.$api.notifications.unsubscribe(token)
          }
        })
      }).catch((err) => {
        console.log('Unable to get permission to notify.', err)
      })
    }*/

  },

  components: { LocaleSelect,Avatar },

  methods: {
    logout () {
      return this.$auth.logout({
        redirect: '/login'
      })
    }
  }
}
</script>
